//
// Copyright 2025 DXOS.org
//

import { Transaction } from '@codemirror/state';

export const initialSync = Transaction.userEvent.of('initial.sync');
